import { render, staticRenderFns } from "./accessHabits.vue?vue&type=template&id=2d1d1e46&scoped=true&"
import script from "./accessHabits.vue?vue&type=script&lang=js&"
export * from "./accessHabits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d1e46",
  null
  
)

export default component.exports